import React, { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import axios from "axios";
import { MailCheck, MailX, Loader2 } from "lucide-react";
import { Section, Overline, H1 } from "@/components/ui-kit";
import { VerificationPanel } from "./ThankYou";

const TITLES = {
  verified: "Your email address is confirmed.",
  already_verified: "This email address was already confirmed.",
  expired: "This confirmation link has expired.",
  invalid: "This confirmation link is not valid or was already used.",
};

export default function VerifyEmail() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [result, setResult] = useState(null);

  useEffect(() => {
    if (!token) { setResult({ status: "invalid" }); return; }
    axios.post("/api/verify-email", { token }).then((r) => setResult(r.data)).catch(() => setResult({ status: "error" }));
  }, [token]);

  const ok = result && ["verified", "already_verified"].includes(result.status);
  return (
    <Section className="pt-20 md:pt-28 pb-24" dataTestId="verify-email-page">
      <div className="max-w-2xl">
        {!result ? (
          <div className="flex items-center gap-3 text-neutral-300"><Loader2 className="animate-spin" size={18} /> Confirming your email address…</div>
        ) : (
          <>
            {ok ? <MailCheck className="text-emerald-400" size={36} strokeWidth={1.4} /> : <MailX className="text-[#C19B6C]" size={36} strokeWidth={1.4} />}
            <Overline className="mt-5">Email confirmation</Overline>
            <H1 className="mt-3" data-testid="verify-result">{TITLES[result.status] || "We could not confirm your email right now."}</H1>
            <p className="text-neutral-300 mt-6 leading-relaxed">
              {ok
                ? `Thank you${result.first_name ? `, ${result.first_name}` : ""}. Someone from Brightside Capital Ventures will contact you shortly.`
                : result.status === "expired"
                  ? "You can request a new link below. Your submission is safe and we will still contact you."
                  : "Your submission is safe. If you need a new confirmation link, use the button on your confirmation page or contact us directly."}
            </p>
            {result.status === "expired" && result.id && <VerificationPanel leadId={result.id} />}
            {ok && result.lead_type === "buyer" && result.property_updates_opt_in && (
              <p className="text-sm text-neutral-400 mt-4" data-testid="updates-status">{result.property_updates_enrolled ? "You are on the property-update list." : "Your property-update preference is saved. We will add you to the list when it goes live."}</p>
            )}
          </>
        )}
        <div className="mt-10 flex flex-wrap gap-3">
          <Link to="/" className="btn-ghost px-6 py-3 text-sm">Back to home</Link>
          <Link to="/contact" className="btn-ghost px-6 py-3 text-sm">Contact us</Link>
        </div>
      </div>
    </Section>
  );
}
